exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "notification-recipients-editor .card{min-width:300px;height:220px}notification-recipients-editor .md-select{margin:0 50px 15px}notification-recipients-editor .md-select .select-dropdown{text-align:center}", ""]);

